import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=30482380&"
import script from "./Filter.vue?vue&type=script&lang=js&"
export * from "./Filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/base/Loader.vue').default})
